<ul class="mb-0 ps-0 d-flex">
  @for (
    breadcrumb of breadcrumbs$ | async;
    track breadcrumb;
    let last = $last
  ) {
    <li class="text-dark d-flex align-items-center me-2 fw-light">
      @if (!last) {
        <a
          class="text-dark"
          [routerLink]="breadcrumb.url"
          queryParamsHandling="merge"
        >
          <fa-icon [icon]="faAngleRight" class="me-1"></fa-icon>
          {{ breadcrumb.label | translate }}
        </a>
      }
      @if (last) {
        <fa-icon [icon]="faAngleRight" class="me-1"></fa-icon>
        {{ breadcrumb.label | translate }}
        @if (breadcrumb.info; as info) {
          <wilson-handbook-info-icon
            class="ms-1"
            [title]="info.titleKey ? (info.titleKey | translate) : ''"
            [content]="info.contentKey | translate"
            [linkUrl]="info.linkUrl"
            [linkText]="
              info.linkTextKey
                ? (info.linkTextKey | translate)
                : ('general.handbook' | translate)
            "
            placement="bottom"
          />
        }
      }
    </li>
  }
</ul>
